export default function Songs() {
  return (
    <div style={{padding:"20px"}}>
      <h1>Temple Songs</h1>
      <p>Audio list will come here</p>
    </div>
  );
}